"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const adminClient_1 = require("client/adminClient");
const useDebounce_1 = __importDefault(require("hooks/useDebounce"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const PaginationModule_1 = __importDefault(require("components/shared/PaginationModule/PaginationModule"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const Modal_1 = __importDefault(require("components/shared/modal/Modal"));
const TruncateParagraph_1 = __importDefault(require("src/components/shared/TruncateParagraph"));
const SelectGroupMember = ({ members, setMembers, isReadOnly, setTotalParticipant }) => {
    const [currentParticipant, setCurrentParticipant] = (0, react_1.useState)([]);
    const [listMember, setListMember] = (0, react_1.useState)([]);
    const [modalOpen, setModalOpen] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isModalLoading, setIsModalLoading] = (0, react_1.useState)(true);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [pagination, setPagination] = (0, react_1.useState)(null);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const { select_all, includes, excludes } = members;
    const debouncedSearchValue = (0, useDebounce_1.default)(searchValue, 1000);
    const checkboxHeader = [{ name: 'checkbox', widthClass: 'w-[56px]' }];
    const tableHeaders = [
        {
            name: (0, HelperUtils_1.getObjectiveLocale)('Participant Group Name'),
            widthClass: 'w-[360px]',
            grow: true
        },
        {
            name: (0, HelperUtils_1.getObjectiveLocale)('Total participants'),
            widthClass: 'w-[160px]',
            useHeaderMargin: false
        },
        { name: '', widthClass: 'w-[160px]' }
    ];
    const getListParticipants = (additionalParams) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { data, pagination: paginationData } = yield (0, adminClient_1.getTeamsCMSCulture)(Object.assign({ q: searchValue, limit: 10 }, additionalParams));
        if (data) {
            setCurrentParticipant(data);
            setPagination({
                olderThan: data.length < 10 ? null : (_a = paginationData === null || paginationData === void 0 ? void 0 : paginationData.next) === null || _a === void 0 ? void 0 : _a.olderThan,
                newerThan: (_b = paginationData === null || paginationData === void 0 ? void 0 : paginationData.prev) === null || _b === void 0 ? void 0 : _b.newerThan
            });
        }
        setIsLoading(false);
    });
    const isAllCheckHandler = () => {
        if (select_all) {
            const FilteredLength = currentParticipant.filter((value) => excludes.indexOf(value.id) > -1).length;
            return FilteredLength === 0;
        }
        else {
            const FilteredLength = currentParticipant.filter((value) => includes.indexOf(value.id) > -1).length;
            return FilteredLength === currentParticipant.length;
        }
    };
    const selectMembers = (e, value) => {
        const checked = e.currentTarget.checked;
        if (checked) {
            handleCheckMembers([value.id]);
        }
        else {
            handleUncheckMembers([value.id]);
        }
    };
    const handleCheckMembers = (ids) => {
        const tempIncludes = JSON.parse(JSON.stringify(includes));
        const tempExcludes = JSON.parse(JSON.stringify(excludes));
        if (select_all) {
            const newArray = tempExcludes.filter((value) => ids.indexOf(value) == -1);
            setMembers(Object.assign(Object.assign({}, members), { excludes: newArray }));
        }
        else {
            const uniqueIds = new Set([...tempIncludes, ...ids]);
            setMembers(Object.assign(Object.assign({}, members), { includes: [...uniqueIds] }));
        }
    };
    const handleUncheckMembers = (ids) => {
        const tempIncludes = JSON.parse(JSON.stringify(includes));
        const tempExcludes = JSON.parse(JSON.stringify(excludes));
        if (select_all) {
            setMembers(Object.assign(Object.assign({}, members), { excludes: tempExcludes.concat(ids) }));
        }
        else {
            const newArray = tempIncludes.filter((value) => ids.indexOf(value) == -1);
            setMembers(Object.assign(Object.assign({}, members), { includes: newArray }));
        }
    };
    const checkAllHandler = () => {
        const arr = [...currentParticipant].map((v) => {
            return v.id;
        });
        if (isAllCheckHandler() == true) {
            handleUncheckMembers(arr);
        }
        else {
            handleCheckMembers(arr);
        }
    };
    const isSelected = (user) => {
        if (select_all) {
            return excludes.indexOf(user.id) === -1 ? true : false;
        }
        else {
            return includes.indexOf(user.id) > -1 ? true : false;
        }
    };
    const changePage = (type) => {
        if (type === 'next') {
            getListParticipants({ olderThan: pagination === null || pagination === void 0 ? void 0 : pagination.olderThan });
            setCurrentPage(currentPage + 1);
        }
        else {
            getListParticipants({ newerThan: pagination === null || pagination === void 0 ? void 0 : pagination.newerThan });
            setCurrentPage(currentPage - 1);
        }
    };
    const getListMember = (id) => __awaiter(void 0, void 0, void 0, function* () {
        setIsModalLoading(true);
        const { data } = yield (0, adminClient_1.getTeamsIdCMSCulture)(id);
        if (data) {
            setListMember(data === null || data === void 0 ? void 0 : data.userDetail);
            setIsModalLoading(false);
        }
    });
    (0, react_1.useEffect)(() => {
        getListParticipants();
        setCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchValue]);
    (0, react_1.useEffect)(() => {
        setTotalParticipant(includes.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [includes]);
    return (react_1.default.createElement("div", { className: "mt-[24px]" },
        isLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SearchBar_1.default, { fullWidth: true, placeholder: "Search group", onChange: (e) => setSearchValue(e.target.value), iconClass: "top-1/3", customClass: "mb-[16px]" }),
            react_1.default.createElement(Table_1.default, { headers: [...(isReadOnly ? [] : checkboxHeader), ...tableHeaders], headerCheckbox: {
                    checked: isAllCheckHandler(),
                    onClick: checkAllHandler,
                    disabled: false
                }, fixedLeftCount: isReadOnly ? 1 : 2 }, currentParticipant === null || currentParticipant === void 0 ? void 0 : currentParticipant.map((participant, index) => (react_1.default.createElement(Table_1.default.Row, { key: `table-row-${index}` },
                !isReadOnly && (react_1.default.createElement(Table_1.default.Column, { key: "table-column-0" },
                    react_1.default.createElement(Checkbox_1.default, { id: `checkbox-${participant === null || participant === void 0 ? void 0 : participant.id}`, name: `checkbox-${participant === null || participant === void 0 ? void 0 : participant.id}`, dataCy: `checkbox-${participant === null || participant === void 0 ? void 0 : participant.id}`, checked: isSelected(participant), onChange: (e) => selectMembers(e, participant), disabled: isReadOnly }))),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 0 : 1}` },
                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h300 text-n-900" }, participant === null || participant === void 0 ? void 0 : participant.name)),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 1 : 2}` },
                    react_1.default.createElement("div", { className: "flex justify-end w-full" },
                        react_1.default.createElement("p", { className: "text-n-900" }, participant === null || participant === void 0 ? void 0 : participant.userCount))),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 2 : 3}` },
                    react_1.default.createElement(Button_1.default.Tertiary, { onClick: () => {
                            setModalOpen(true);
                            getListMember(participant === null || participant === void 0 ? void 0 : participant.id);
                        } }, (0, HelperUtils_1.getObjectiveLocale)('View Members'))))))),
            react_1.default.createElement("div", { className: "flex justify-end w-full mt-[12px]" },
                react_1.default.createElement(PaginationModule_1.default, { pageNumber: currentPage, handlePrev: () => changePage('prev'), handleNext: () => changePage('next'), hasMore: (pagination === null || pagination === void 0 ? void 0 : pagination.olderThan) !== null })))),
        modalOpen && (react_1.default.createElement(Modal_1.default, { className: "w-[400px]", maxHeight: 488, title: (0, HelperUtils_1.getObjectiveLocale)('Members'), withCloseIcon: true, eventOnClickClose: () => setModalOpen(false), withFooter: false, contentClass: "overflow-auto" }, isModalLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (listMember.length > 0 &&
            listMember.map((member, index) => (react_1.default.createElement(ProfileType_1.default, { key: index, user: member, title: member === null || member === void 0 ? void 0 : member.name, subtitle: (member === null || member === void 0 ? void 0 : member.jobTitle) || '-', size: 32, titleClassName: "typography-h400", subtitleClassName: "typography-h100" }))))))));
};
exports.default = SelectGroupMember;
